const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const GenerateHolidays = async (schoolId, trainingId, accessToken) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/tasks/import-calendar-bank-holidays",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de génération des jours fériés!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const GenerateTrainingSessions = async (
  schoolId,
  trainingId,
  accessToken,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/tasks/generate-schedule-sessions",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de génération des sessions de cours!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const ImportFromTraining = async (
  schoolId,
  trainingId,
  accessToken,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/tasks/import-from-training",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur d'importation des données!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
}

const ImportRegistrationsFromTraining = async (
  schoolId,
  trainingId,
  accessToken,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/tasks/import-registrations-from-training",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur d'importation des élèves!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
}

const UpdateRegistrationsStatus = async (
  schoolId,
  trainingId,
  accessToken,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/tasks/update-registrations-status",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur d'importation des données!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
}

const UpdateStudentsClass = async (
  schoolId,
  trainingId,
  accessToken,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/tasks/update-students-class",
      {
        method: "POST",
        body: JSON.stringify(data), // { students_ids: ["id1", "id2"], new_class_id: "1234" }
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de mise à jour des affectations de classe d'étudiants!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
}

const UpdateStudentsResult = async (
  schoolId,
  trainingId,
  accessToken,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/tasks/update-students-result",
      {
        method: "POST",
        body: JSON.stringify(data), // { students_ids: ["id1", "id2"], new_result: "PASSED" }
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de mise à jour des résultats!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
}

const GenerateSchedule = async (
  schoolId,
  trainingId,
  accessToken,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/tasks/generate-schedule-entries",
      {
        method: "POST",
        body: JSON.stringify(data || {}),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de génération des cours!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
}

const ExportStudentsToExcelFile = async (
  schoolId,
  trainingId,
  accessToken,
  data
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/tasks/export-students-to-excel-file",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur d'importation des élèves!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
}

const GenerateContracts = async (
  schoolId,
  trainingId,
  accessToken
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/tasks/generate-students-contracts",
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de génération des contrats!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
}

const GetTask = async (
  schoolId, trainingId, jobId, accessToken
) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" + trainingId + "/tasks/" +
      jobId,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de récupération du détail de la tâche!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const tasksAPI = {
  GenerateHolidays,
  GenerateTrainingSessions,
  ImportFromTraining,
  ImportRegistrationsFromTraining,
  GenerateSchedule,
  UpdateRegistrationsStatus,
  UpdateStudentsClass,
  UpdateStudentsResult,
  ExportStudentsToExcelFile,
  GenerateContracts,
  GetTask,
};

export default tasksAPI;
